module.exports = __webpack_public_path__ + "static/media/header_register.e93cfc1b.jpg";